import * as tenantApi from '../../api/tenant';
import { tenant, success, error } from '../state';

function persist() {
  localStorage.setItem('tenant', JSON.stringify(tenant.value));
}

export async function loadMyTenant() {
  try {
    tenant.value = await tenantApi.fetchMyTenant();
    persist();
  } catch (err) {
    error.value = (err as Error).message;
  }
}

export async function guardarLogoEmpresa(dataUrl: string) {
  try {
    const { logoUrl } = await tenantApi.uploadTenantLogo(dataUrl);
    if (tenant.value) tenant.value = { ...tenant.value, logoUrl };
    persist();
    success.value = 'Logo actualizado.';
  } catch (err) {
    error.value = (err as Error).message;
  }
}

export async function quitarLogoEmpresa() {
  try {
    await tenantApi.deleteTenantLogo();
    if (tenant.value) tenant.value = { ...tenant.value, logoUrl: null };
    persist();
    success.value = 'Logo eliminado.';
  } catch (err) {
    error.value = (err as Error).message;
  }
}
